import React, { useState, useRef, } from 'react';
//import global components
import { Tab } from '@headlessui/react';


//import icons from heroicons
import { PlusCircleIcon} from '@heroicons/react/24/outline';
import { ObtenerEspecialidades } from '../../../../servicios/ServicioInfoPersonal';
import { ObtenerTecnologiasPorIdEspecializacion } from '../../../../servicios/ServicioTecnologia';
import { CustomTabComponent } from '../../FilterComponent/filterComponent';
import { useLoader } from '../../../../context/LoaderContext.';
import { useEffect } from 'react';
import { ObtenerEtapasProyecto } from '../../../../servicios/ServicioProyectoEmpresa';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const AddProjectComponent = ({ errors, listUserTechnologies, setListUserTechnologies, etapas, register, fieldNames = {nombreProyecto:"nombreProyecto",descripcion:"descripcion",etapaProyecto:"etapaProyecto"} }) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedIndexSecondPanel, setSelectedIndexSecondPanel] = useState(0);
    const [specialtyOptions, setSpecialtyOptions] = useState([]);
    const [etapasProyecto, setEtapasProyecto] = useState([]);
    const [listTechnologies, setListTechnologies] = useState([]);
    const checkbox = useRef([]);
    const { showLoader, hideLoader } = useLoader();

    async function getEtapas() {
        const response = await ObtenerEtapasProyecto();
        if (response !== undefined) {
            console.log(response)
            setEtapasProyecto(response);
        }

    }

    async function getEspecialties() {
        const response = await ObtenerEspecialidades();
        if (response !== undefined) {

            setSpecialtyOptions(response);

        }

    }

    async function changeListTech(index) {
        const response = await ObtenerTecnologiasPorIdEspecializacion(index);
        setListTechnologies(response);
    }

    const detect = (event) => {
        const idTech = event.currentTarget.id
        //here we delete value from array if user uncheck input
        if (checkbox.current[idTech]?.checked) {


            let techCheckedObject = {
                id: idTech,
                checked: true,
            };


            //filter array to validate if object exists and then update value
            const filtered = listUserTechnologies.filter(obj => {
                return obj.id === idTech;
            });
            if (filtered.length > 0) {
                const newArray = listUserTechnologies.map(item => {
                    if (idTech === item.id) {
                        return { ...item };
                    } else {
                        return item;
                    }
                });
                setListUserTechnologies(newArray);
            } else {
                setListUserTechnologies(prev => [...prev, techCheckedObject])

            }
        } else {

            //filter array to validate if object exists and then update value
            const filtered = listUserTechnologies.filter(obj => {
                return obj.id === idTech;
            });

            if (filtered.length > 0) {
                const newArray = listUserTechnologies.filter(item => {
                    return item.id !== idTech;
                });
                setListUserTechnologies(newArray);
            } else if (filtered.length === 0) {
                listUserTechnologies.forEach((item) => {

                    listUserTechnologies.splice(item, 1);

                });
            }
        }
    }

    useEffect(() => {
        showLoader();
        getEspecialties();
        //getEtapas();
        hideLoader();
     
    }, [])



    return (
        <>
            <div className="container mx-auto max-w-4xl">
                {/* Formulario */}
                <form className="space-y-4 md:space-y-6 w-full mb-4">
                    <div className="text-center">
                        <PlusCircleIcon className="w-8 h-8 text-green-500 mx-auto mb-2" />
                        <h1 className="text-base font-bold text-white">Agregar Proyecto</h1>
                    </div>

                    <div className="flex flex-col gap-4">
                        {/* Fila Nombre y Etapa */}
                        <div className="flex flex-col md:flex-row gap-4">
                            {/* Nombre del Proyecto */}
                            <div className="w-full">
                                <label className="block mb-2 text-sm font-medium text-white">Nombre*</label>
                                <input
                                    type="text"
                                    {...register(fieldNames.nombreProyecto, { required: 'El nombre del proyecto es obligatorio', maxLength: 32 })}
                                    id="nombreProyecto"
                                    className="text-gray-900 sm:text-sm block w-full p-3 rounded border-2 border-grayDark-RS"
                                    placeholder="Nombre"
                                />
                                {errors[fieldNames.nombreProyecto] && (
                                    <span className="text-red-500 text-sm">{errors[fieldNames.nombreProyecto].message}</span>
                                )}
                            </div>

                            {/* Etapa del Proyecto */}
                            <div className="w-full">
                                <label className="block mb-2 text-sm font-medium text-white">Etapa*</label>
                                <select
                                    id="etapaProyecto"
                                    {...register(fieldNames.etapaProyecto, { required: 'La etapa es requerida' })}
                                    className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-2 border-grayDark-RS"
                                >
                                    <option value="" defaultValue>-- Seleccione la etapa del proyecto --</option>

                                    {etapas?.map((option, index) => (
                                        <option key={index} value={option.idEtapa}>{option.nombre}</option>
                                    ))}

                                </select>
                                {errors[fieldNames.etapaProyecto] && (
                                    <span className="text-red-500 text-sm">{errors[fieldNames.etapaProyecto].message}</span>
                                )}
                            </div>
                        </div>

                        {/* Descripci�n del Proyecto */}
                        <div className="w-full">
                            <label className="block mb-2 text-sm font-medium text-white">Acerca de*</label>
                            <textarea
                                {...register(fieldNames.descripcion, { required: 'La descripci�n es obligatoria', maxLength: 255 })}
                                id="descripcion"
                                className="text-gray-900 sm:text-sm block w-full p-3 rounded border-2 border-grayDark-RS"
                                placeholder="Acerca de"
                                rows="4"
                            />
                            {errors[fieldNames.descripcion] && (
                                <span className="text-red-500 text-sm">{errors[fieldNames.descripcion].message}</span>
                            )}
                        </div>
                    </div>
                </form>

                {/* Tab Group */}
                <h1 className="text-base text-center font-bold leading-tight tracking-tight">Tecnologias</h1>
                <Tab.Group selectedIndex={selectedIndexSecondPanel} onChange={setSelectedIndexSecondPanel}>
                    <div className="w-full bg-white rounded-lg shadow-lg flex gap-4">
                        {/* Tab List */}
                        <div className="w-1/4 border border-grayDark-RS">
                            <Tab.List className="flex flex-col">
                                {specialtyOptions.map((value, index) => (
                                    <Tab
                                        key={index}
                                        className={({ selected }) =>
                                            classNames(
                                                'w-full py-2.5 text-base font-bold text-black-RS',
                                                selected ? 'bg-gray-500 text-grayLight-RS' : 'hover:bg-grayLight-RS'
                                            )
                                        }
                                    >
                                        {value.nombreEspecializacion}
                                    </Tab>
                                ))}
                            </Tab.List>
                        </div>

                        {/* Tab Panels */}
                        <div className="flex-grow min-h-[300px]">
                            <Tab.Panels>
                                {specialtyOptions.map((value, index) => (
                                    <Tab.Panel key={index} className="h-full">
                                        <CustomTabComponent
                                            key={value.idEspecializacion}
                                            idEspecializacion={value.idEspecializacion}
                                            onChangeListTech={changeListTech}
                                            listTechnologies={listTechnologies}
                                            checkbox={checkbox}
                                            detect={detect}
                                            selectedIndex={selectedIndex}
                                            selectedIndexSecondPanel={selectedIndexSecondPanel}
                                            listUserTechnologies={listUserTechnologies}
                                            setListUserTechnologies={setListUserTechnologies}
                                        />
                                    </Tab.Panel>
                                ))}
                            </Tab.Panels>
                        </div>
                    </div>
                </Tab.Group>
            </div>


        </>
    )
}